import { render, staticRenderFns } from "./AppSkeletonLoader.vue?vue&type=template&id=0f951af8&scoped=true&"
import script from "./AppSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./AppSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./AppSkeletonLoader.vue?vue&type=style&index=0&id=0f951af8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f951af8",
  null
  
)

export default component.exports